import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-373c8cc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  id: "header",
  class: "row border-bottom py-5"
}
const _hoisted_3 = { class: "col d-flex align-items-center" }
const _hoisted_4 = { class: "row align-items-center w-100" }
const _hoisted_5 = { class: "col-1 text-center" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = {
  class: "font-weight-bold from-style",
  title: "Search Emails"
}
const _hoisted_8 = {
  class: "font-weight-bold from-style",
  title: "Search Emails"
}
const _hoisted_9 = { class: "text-secondary" }
const _hoisted_10 = {
  id: "content",
  class: "row overflow-auto"
}
const _hoisted_11 = { class: "col-12 col-lg-8 offset-lg-2" }
const _hoisted_12 = { class: "overflow-scroll" }
const _hoisted_13 = { class: "mt-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "email-body",
  style: {"border":"none"},
  class: "mt-3"
}, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Attachments", -1))
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  id: "header",
  class: "row border-bottom py-5"
}
const _hoisted_19 = { class: "col d-flex align-items-center" }
const _hoisted_20 = { class: "row align-items-center w-100" }
const _hoisted_21 = { class: "col-1 text-center" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = {
  class: "font-weight-bold from-style",
  title: "Search Emails"
}
const _hoisted_24 = {
  class: "font-weight-bold from-style",
  title: "Search Emails"
}
const _hoisted_25 = { class: "text-secondary" }
const _hoisted_26 = {
  id: "content",
  class: "row overflow-auto"
}
const _hoisted_27 = { class: "col-12 col-lg-8 offset-lg-2" }
const _hoisted_28 = { class: "overflow-scroll" }
const _hoisted_29 = { class: "mt-3" }
const _hoisted_30 = ["id", "innerHTML"]
const _hoisted_31 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Attachments", -1))
const _hoisted_33 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (Object.keys(_ctx.email).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, {
                  class: "text-secondary",
                  icon: ['fas', 'user-circle'],
                  size: "3x"
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, " From: " + _toDisplayString(_ctx.email.from), 1),
                _createElementVNode("div", _hoisted_8, " To: " + _toDisplayString(_ctx.email.to), 1),
                _createElementVNode("div", null, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "text-secondary mr-2",
                    icon: ['far', 'clock']
                  }),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$filters.dateTime(_ctx.email.dateCreated)), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.email.subject), 1),
                _hoisted_14,
                (_ctx.email.attachments.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "text-secondary",
                        icon: ['fas', 'paperclip']
                      }),
                      _hoisted_16,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.email.attachments, (attachment) => {
                        return (_openBlock(), _createElementBlock("a", {
                          href: attachment.path,
                          class: "d-block overflow-hidden p-2",
                          key: attachment.id
                        }, _toDisplayString(attachment.filename), 9, _hoisted_17))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.email.replies, (reply) => {
            return (_openBlock(), _createElementBlock("div", {
              key: reply.id,
              class: "col-12 border-top mt-3 pt-3"
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "text-secondary",
                        icon: ['fas', 'user-circle'],
                        size: "3x"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, " From: " + _toDisplayString(reply.from), 1),
                      _createElementVNode("div", _hoisted_24, " To: " + _toDisplayString(reply.to), 1),
                      _createElementVNode("div", null, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "text-secondary mr-2",
                          icon: ['far', 'clock']
                        }),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$filters.dateTime(reply.dateCreated)), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h4", _hoisted_29, _toDisplayString(reply.subject), 1),
                      _createElementVNode("div", {
                        id: reply.id,
                        style: {"border":"none"},
                        class: "mt-3",
                        innerHTML: reply.body
                      }, null, 8, _hoisted_30),
                      (reply.attachments.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createVNode(_component_font_awesome_icon, {
                              class: "text-secondary",
                              icon: ['fas', 'paperclip']
                            }),
                            _hoisted_32,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reply.attachments, (attachment) => {
                              return (_openBlock(), _createElementBlock("a", {
                                href: attachment.path,
                                class: "d-block overflow-hidden p-2",
                                key: attachment.id
                              }, _toDisplayString(attachment.filename), 9, _hoisted_33))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}